import React from "react";
import "./components.css";
// import accordeon module
import Collapsible from "react-collapsible";
// import icons pack
import Ionicon from "react-ionicons";
// material components
import Button from "@material-ui/core/Button";
import Fab from "@material-ui/core/Fab";

const closeState = textnode => (
  <React.Fragment>
    {textnode}

    <Fab size="small" className="absIcon" >
      <Ionicon
        icon="ios-add"
        fontSize="30px"
        color="#ff1053"
        
      />
    </Fab>
  </React.Fragment>
);
const openState = textnode => (
  <React.Fragment>
    {textnode}
    <Fab size="small" className="absIcon" >
      <Ionicon
        icon="ios-remove"
        fontSize="30px"
        color="#ff1053"
      />
    </Fab>
  </React.Fragment>
);

const accordeonList = [
  {
    title: "How to apply for the program?",
    text: `Lorem ipsum dolor sit amet, consectetuer adipiscing elit,
      sed diam nonummy nibh euismod tincidunt ut laoreet dolore
      magna aliquam erat volutpat. Ut wisi enim ad minim veniam,
      quis nostrud exerci tation ullamcorper suscipit lobortis
      nisl ut aliquip ex ea commodo consequat. Duis autem vel eum
    `
  },
  {
    title: "How to attract traffic to my product page?",
    text: `Lorem ipsum dolor sit amet, consectetuer adipiscing elit,
      sed diam nonummy nibh euismod tincidunt ut laoreet dolore
      magna aliquam erat volutpat. Ut wisi enim ad minim veniam,
      quis nostrud exerci tation ullamcorper suscipit lobortis
    `
  },
  {
    title: "How to apply for the program?",
    text: `Lorem ipsum dolor sit amet, consectetuer adipiscing elit,
    sed diam nonummy nibh euismod tincidunt ut laoreet dolore
    magna aliquam erat volutpat. Ut wisi enim ad minim veniam,
    `
  },
  {
    title: "How to apply for the program?",
    text: `Lorem ipsum dolor sit amet, consectetuer adipiscing elit,
    sed diam nonummy nibh euismod tincidunt ut laoreet dolore
    magna aliquam erat volutpat. Ut wisi enim ad minim veniam,
    quis nostrud exerci tation ullamcorper suscipit lobortis
    nisl ut aliquip ex ea commodo consequat. Duis autem vel eum
    `
  }
];
export const Accordeon = () => (
  <div className="sectionAccordeon">
    <div className="sectionHeading">Q &amp; A</div>
    <div className="accordeon">
      {accordeonList.map(item => (
        <Collapsible
          trigger={closeState(item.title)}
          transitionTime={50}
          triggerWhenOpen={openState(item.title)}
          easing="ease"
        >
          <p>{item.text}</p>
        </Collapsible>
      ))}
    </div>
  </div>
);
